/**
 * PhoneIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const PhoneIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M21 16.81a3.3 3.3 0 0 0-.3-.81l-6-1a3.5 3.5 0 0 0-.85 1.78 10.74 10.74 0 0 1-6.65-6.63A3.5 3.5 0 0 0 9 9.29l-1-6a3.2 3.2 0 0 0-.83-.24A3 3 0 0 0 6.6 3 3.6 3.6 0 0 0 3 6.6C3 14.553 9.447 21 17.4 21a3.6 3.6 0 0 0 3.6-3.6 4 4 0 0 0 0-.59" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const PhoneIcon = makeIcon('PhoneIcon', PhoneIconSvg)
